import { alpha } from '@mui/material/styles';
import React from 'react';
import {
  styled,
  Icons,
  Accordion as MuiAccordion,
  Stack,
  Text,
} from '@/theme/index';

export const SafeBar = () => {
  return (
    <StyledStack
      direction="row"
      alignItems="center"
      sx={(theme) => ({
        backgroundColor: theme.palette.threatDetection?.light,
      })}
    >
      <Icons.VerifiedUser
        sx={(theme) => ({
          color: theme.palette.threatDetection?.dark,
          marginRight: theme.spacing(1),
        })}
        color="success"
        width="16px"
      />
      <Text
        mr={1}
        sx={(theme) => ({ color: theme.palette.threatDetection?.dark })}
        fontWeight="bold"
      >
        No Threat Detected
      </Text>
    </StyledStack>
  );
};

export const SpamBar = () => {
  return (
    <StyledStack
      direction="row"
      alignItems="center"
      sx={(theme) => ({
        backgroundColor: theme.palette.threatDetection?.contrastText,
      })}
    >
      <Icons.ReportProblem
        sx={(theme) => ({
          color: theme.palette.threatDetection?.main,
          marginRight: theme.spacing(1),
        })}
        width="19px"
      />
      <Text>
        <Text
          component="span"
          mr={1}
          sx={(theme) => ({ color: theme.palette.threatDetection?.main })}
          fontWeight="bold"
        >
          Attention! Potential SPAM / scam caller
        </Text>
        <Text component="span">
          Please use caution if you interact with this number!
        </Text>
      </Text>
    </StyledStack>
  );
};

export const Accordion = styled(MuiAccordion)(({ theme }) => ({
  border: 'none',
  borderTop: `1px solid ${theme.palette.divider}`,
  backgroundColor: 'transparent',

  p: {
    color: 'black',
  },

  '&:before': {
    display: 'none',
  },
  '&:hover': {
    boxShadow: 'none',
  },
  '&:last-child': {
    borderBottom: 'none',
  },

  '.MuiAccordionSummary-root, .MuiAccordionSummary-root.Mui-expanded': {
    flexDirection: 'row-reverse',
    gap: theme.spacing(1),
    padding: 0,
  },

  '.MuiAccordionDetails-root': {
    padding: theme.spacing(0, 2, 2, 0),
  },
}));

const StyledStack = styled(Stack)(() => ({
  borderRadius: '5px',
  padding: '8px',
}));

export const StyledSmallContainer = styled(Stack)(({ theme }) => ({
  width: '100%',
  height: '97.5px',
  border: `1px solid ${alpha(theme.palette.primary.main, 0.1)}`,
  borderRadius: '5px',
}));

export const StyledLargeContainer = styled(Stack)(({ theme }) => ({
  width: '100%',
  height: '203px',
  border: `1px solid ${alpha(theme.palette.primary.main, 0.1)}`,
  borderRadius: '5px',

  [theme.breakpoints.up('lg')]: {
    width: '32%',
  },
}));
